export const formatCpf = (v) => {
  const d = (v || "").replace(/\D/g, "").slice(0, 11);
  return d
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};

export const isValidCpf = (v) => {
  const d = (v || "").replace(/\D/g, "");
  if (d.length !== 11 || /^(\d)\1{10}$/.test(d)) return false;
  for (const n of [9, 10]) {
    let total = 0;
    for (let i = 0; i < n; i++) total += +d[i] * (n + 1 - i);
    if (((total * 10) % 11) % 10 !== +d[n]) return false;
  }
  return true;
};
